import MatrixData from "./../Teachers/Components/MatrixData";
import { useEffect, useState } from "react";
import Table from "./../Teachers/Components/Table";
import LineChart from "../../../Components/Charts/LineChart";
import RadarChart from "../../../Components/Charts/RadarChart";
import brain from "../../../Assets/Images/brain.svg";
import bulb from "../../../Assets/Images/bulb.svg";
import multiUsers from "../../../Assets/Images/multi-users.svg";
import socio from "../../../Assets/Images/socio.svg";
import sports from "../../../Assets/Images/sports.svg";
import "./style.css";
import { useDispatch, useSelector } from "react-redux";
import {
  setFilters,
  studentsByCategory,
} from "../../../redux/actions/dashboard";
import Filters from "../Components/Filters";
import { TEACHER_FILTER } from "../../../redux/actions/types";
import Widget from "./Components/Widget";
import { lineChartConfigs, radarConfigs, teacherActiveFilter } from "../../../helper/general";
import { isMobileDevice } from "../../../helper";

const Teachers = () => {

  const graphIcons = {
    "Cognitive Skills": brain,
    "Creativity & Imagination Skills": bulb,
    "Language & Communication Skills": multiUsers,
    "Physical Skills": sports,
    "Socio-Emotional Skills": socio
  }

  const isMobile = isMobileDevice();
  const dispatch = useDispatch();

  const studentData = useSelector((state) => state.dashboard.studentData);
  const teacherFilter = useSelector((state) => state.dashboard.teacherFilter);

  const [reload, setReload] = useState(0);

  useEffect(() => {
    dispatch(studentsByCategory(teacherFilter));
  }, [reload]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    const data = { ...teacherFilter };
    const index = data[name]?.indexOf(parseInt(value));
    if (index >= 0) {
      data[name].splice(index, 1);
    } else {
      data[name].push(parseInt(value));
    }
    dispatch(setFilters(TEACHER_FILTER, data));
    setReload(Math.random());
  };

  const chartData = {
    labels: studentData?.categoryWiseResponse?.map?.((item) => item?.name),
    datasets: [
      {
        label: "",
        fill: false,
        borderColor: "#2B5CAA",
        data: studentData?.categoryWiseResponse?.map((item) =>
          Math.ceil(item?.averageScore)
        ),
      },
    ],
  };

  const radarData = {
    labels: isMobile ? studentData?.categoryWiseResponse?.filter((item) => item?.isTheme)?.map((item) => "") : studentData?.categoryWiseResponse?.filter((item) => item?.isTheme)?.map((item) => (`${item?.name} ${Math.ceil(item?.averageScore)}%`)),
    datasets: [
      {
        label: "",
        backgroundColor: "rgba(255, 210, 240,0.5)",
        data: studentData?.categoryWiseResponse
          ?.filter((item) => item?.isTheme)
          ?.map((item) => Math.ceil(item?.averageScore)),
        borderColor: "#FFD2F0",
        fill: true,
      },
    ],
  };

  return (
    <div className="container-fluid">
      <Filters handleFilterChange={handleFilterChange} filterData={teacherFilter} activeFilter={teacherActiveFilter} />
      <MatrixData stats={studentData} />
      <div className="performace-pillar shadow card mx-2 my-4 border-0">
        <p className="hdng-para">
          Avg performance of students across each dev pillar
        </p>
        <div className="pillar-figure pillar-sec mx-auto">
          {isMobile &&
            <ul className="mob-report-list">
              {studentData?.categoryWiseResponse?.filter((item) => item?.isTheme)?.map((item) => {
                return (
                  <li className="mb-1"><img className="img-brain mx-1" width={20} src={graphIcons[item?.name]} alt="brain" /> {item?.name}</li>
                )
              })}
            </ul>
          }
          <div className="figure-img d-flex justify-content-center my-4 mx-auto">
            <RadarChart chartData={radarData} options={radarConfigs} />
            <img className="img-brain" src={brain} alt="brain" />
            <img className="creativity-img" src={bulb} alt="bulb" />
            <img className="lang-img" src={multiUsers} alt="multiUsers" />
            <img className="phy-skill" src={sports} alt="sports" />
            <img className="socio-skill" src={socio} alt="socio" />
          </div>
        </div>
        <Table data={studentData?.categoryWiseResponse} />
      </div>
      <div className="line-chart shadow card mx-2 my-4 border-0">
        <p className="hdng-para">Avg performance of students overall</p>
        <div className="chart-wrapper">
          <div className="chart-data">
            <LineChart chartData={chartData} options={lineChartConfigs} />
          </div>
        </div>
      </div>
      <Widget stats={studentData} />
    </div>
  );
};

export default Teachers;
